import React, { useEffect, useState } from "react";
import { Card, Typography, Spin, message, Tag, Row, Col, Divider, Button } from "antd";
import axios from "axios";
import SummaryApi from "../common/index";
import { useNavigate } from "react-router-dom";
import { formatStatus } from "../common/formatStatus";

const { Title, Text } = Typography;

const statusColors = {
  paid: "green",
  pending: "orange",
  failed: "red",
  cancelled: "volcano",
};

const UserOrders = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const defaultImage = "/images/default.jpg"; // ✅ default fallback image

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const token = localStorage.getItem("token");
        const { data } = await axios.get(SummaryApi.getUserOrders.url, {
          headers: { Authorization: `Bearer ${token}` },
          withCredentials: true,
        });
        if (data.success) {
          setOrders(data.orders);
        } else {
          message.error("Failed to fetch orders");
        }
      } catch (err) {
        console.error("Error fetching orders:", err);
        message.error("Something went wrong while fetching orders");
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);

  if (loading)
    return (
      <Spin
        tip="Loading your orders..."
        style={{ display: "block", margin: "80px auto" }}
        size="large"
      />
    );

  if (!orders.length)
    return (
      <Text style={{ display: "block", textAlign: "center", marginTop: "60px" }}>
        You haven't placed any orders yet.
      </Text>
    );

  return (
    <div style={{ padding: "20px" }}>

      <Row gutter={[16, 16]}>
        {orders.map((order) => (
          <Col xs={24} md={12} lg={8} key={order.id}>
            <Card
              bordered
              hoverable
              style={{
                borderRadius: 10,
                boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 10,
                }}
              >
                <Text strong>{order.order_number}</Text>
                <Tag color={statusColors[order.status?.toLowerCase()] || "blue"}>
                  {formatStatus(order.status)}
                </Tag>
              </div>

              <Text type="secondary">
                Date: {new Date(order.createdAt).toLocaleString()}
              </Text>
              <Divider style={{ margin: "10px 0" }} />

              <div>
                {order.items.map((item) => {
                  // ✅ Fallback-safe image logic
                  let firstImage = defaultImage;

                  if (item.product?.image) {
                    if (Array.isArray(item.product.image) && item.product.image.length > 0) {
                      firstImage = `${BASE_URL}${item.product.image[0]}`;
                    } else if (typeof item.product.image === "string") {
                      firstImage = `${BASE_URL}${item.product.image.replace(/[[\]"]+/g, "")}`;
                    }
                  }

                  return (
                    <div
                      key={item.id}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        marginBottom: 10,
                      }}
                    >
                      <img
                        src={firstImage}
                        alt={item.product.name}
                        style={{
                          width: 50,
                          height: 50,
                          objectFit: "cover",
                          borderRadius: 8,
                        }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = defaultImage;
                        }}
                      />
                      <div>
                        <Text strong>{item.product.name}</Text>
                        <br />
                        <Text type="secondary">
                          Qty: {item.quantity} × ₹{item.price}
                        </Text>
                      </div>
                    </div>
                  );
                })}
              </div>

              <Divider style={{ margin: "10px 0" }} />
              <Text strong>Total: ₹{order.totalAmount}</Text>

              <Button
                
                block
                style={{ marginTop: 10, backgroundColor: "#1129ce", color: "white", fontWeight: "bold" }}
                onClick={() => navigate(`/orders/${order.id}`)}
              >
                View Details
              </Button>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default UserOrders;
